module.exports = __webpack_public_path__ + "static/img/beachball.6751c71.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/beachball.png
// module id = F27d
// module chunks = 0